import { render, staticRenderFns } from "./ReglaFormulario.vue?vue&type=template&id=49388e8f&scoped=true"
import script from "./ReglaFormulario.vue?vue&type=script&lang=js"
export * from "./ReglaFormulario.vue?vue&type=script&lang=js"
import style0 from "./ReglaFormulario.vue?vue&type=style&index=0&id=49388e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49388e8f",
  null
  
)

export default component.exports